import { authFetch } from "./authFetch";

export default async function getData(endpointValue: string) {
  try {
    const response = await authFetch(endpointValue, {
      method: "GET",
      credentials: "include",
    });

    const contentType = response.headers.get("content-type");
    let data: any = null;

    if (contentType && contentType.includes("application/json")) {
      data = await response.json();
    } else {
      data = await response.text();
    }

    if (!response.ok) {
      throw new FetchError(
        typeof data === "string" ? data : data?.message ?? "Виникла невідомо помилка. Спробуйте, ще раз!",
        response.status
      );
    }

    return data;
  } catch (error: any) {
    if (error instanceof FetchError) {
      throw error;
    }

    throw new FetchError(
      error.message || "Network error or invalid response",
      404
    );
  }
}


export class FetchError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "FetchError";
    this.status = status;
  }
}